module.exports = __webpack_public_path__ + "img/youtube.8d087817.svg";